module.exports = __webpack_public_path__ + "static/img/henan_light.e3f0b9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/henan_light.png
// module id = zQc5
// module chunks = 1